import moment from 'moment';
import { api } from 'common';
import { useRef } from 'react';
import { Column } from 'material-table';
import { IPromoType } from 'common/src/types';
import { useTranslation } from "react-i18next";
import TextField from '@mui/material/TextField';
import { useSelector, useDispatch } from "react-redux";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { CustomMaterialTable } from 'components/CustomMaterialTable';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

export default function Promos() {
  const { editPromo } = api;
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const promodata = useSelector(state => state.promodata);
  const settings = useSelector(state => state.settingsdata.settings);

  if (!settings) return;



  const columns: Column<IPromoType>[] = [
    {
      title: t('promo_name'),
      field: 'promo_name'
    },
    {
      title: t('description'),
      field: 'promo_description'
    },
    {
      title: t('type'),
      field: 'promo_discount_type',
      lookup: {
        flat: t('flat'),
        percentage: t('percentage')
      },
    },
    {
      type: 'numeric',
      field: 'promo_discount_value',
      title: t('promo_discount_value'),
    },
    {
      type: 'numeric',
      title: t('max_limit'),
      field: 'max_promo_discount_value',
    },
    {
      type: 'numeric',
      field: 'min_order',
      title: t('min_limit'),
    },
    {
      title: t('end_date'),
      field: 'promo_validity',
      editComponent: props => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateTimePicker
            autoFocus={false}
            inputRef={inputRef}
            label="DateTimePicker"
            renderInput={(props) => <TextField {...props} />}
            onChange={(newValue) => { props.onChange(newValue) }}
            value={props.rowData.promo_validity ? props.rowData.promo_validity : new Date()}
          />
        </LocalizationProvider>
      ),
      render: rowData => rowData.promo_validity ? moment(rowData.promo_validity).format('DD/MM/YYYY HH:mm') : null,
    },
    {
      type: 'numeric',
      title: t('promo_usage'),
      field: 'promo_usage_limit',
    },
    {
      editable: 'never',
      field: 'user_avail',
      title: t('promo_used_by'),
    }
  ];

  return (
    <CustomMaterialTable
      columns={columns}
      title={'promo_offer'}
      data={promodata.promos ?? []}
      editable={{
        onRowAdd: newData =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              if (!(newData.promo_name && newData.promo_description && newData.promo_discount_value && newData.promo_discount_type && newData.promo_discount_value && newData.max_promo_discount_value && newData.min_order && newData.promo_usage_limit && (newData.min_order >= newData.max_promo_discount_value) && (newData.promo_discount_value >= newData.max_promo_discount_value))) {
                alert(t('no_details_error'));
                reject();
              } else {
                newData['createdAt'] = new Date().getTime();
                newData['promo_validity'] = newData.promo_validity ? new Date(newData.promo_validity).getTime() : null;
                dispatch(editPromo(newData, "Add"));
                resolve("");
              }
            }, 600);
          }),
        onRowUpdate: (newData, oldData) =>
          settings.AllowCriticalEditsAdmin ?
            new Promise((resolve, reject) => {
              setTimeout(() => {
                if (!(newData.promo_name && newData.promo_description && newData.promo_discount_value && newData.promo_discount_type && newData.promo_discount_value && newData.max_promo_discount_value && newData.min_order && newData.promo_usage_limit && (newData.min_order >= newData.max_promo_discount_value) && (newData.promo_discount_value >= newData.max_promo_discount_value))) {
                  alert(t('no_details_error'));
                  reject();
                } else {
                  resolve("");
                  newData['promo_validity'] = newData.promo_validity ? new Date(newData.promo_validity).getTime() : null;
                  if (newData !== oldData) {
                    delete (newData as any).tableData;
                    dispatch(editPromo(newData, "Update"));
                  }
                }
              }, 600);
            })
            :
            new Promise(resolve => {
              setTimeout(() => {
                resolve("");
                alert(t('demo_mode'));
              }, 600);
            }),
        onRowDelete: oldData =>
          settings.AllowCriticalEditsAdmin ?
            new Promise(resolve => {
              setTimeout(() => {
                resolve("");
                dispatch(editPromo(oldData, "Delete"));
              }, 600);
            })
            :
            new Promise(resolve => {
              setTimeout(() => {
                resolve("");
                alert(t('demo_mode'));
              }, 600);
            })
      }}
    />
  );
}
